import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { NodConfigurationRoute } from "./configuration.routes";

export function Configuration() {
  return (
    <Layout>
      {NodConfigurationRoute.subRoutes && (
        <ModuleRouter
          subRoutes={NodConfigurationRoute.subRoutes}
          path={NodConfigurationRoute.path}
        />
      )}
    </Layout>
  );
}
